var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('base-card',[_c('iframe',{staticStyle:{"min-height":"100vh"},attrs:{"src":_vm.logsUrl,"width":"100%","frameborder":"0"}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }